import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@mui/material'
import { ArrowBackIos } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'


export const BackButton = () => {
  const { t } = useTranslation('others')
  const history = useHistory()

  return (
    <Button color="secondary" variant="contained" aria-label="back" style={{textTransform: 'none'}} onClick={() => history.goBack()}>
      <ArrowBackIos fontSize="inherit" />{t('back')}
    </Button>
  )
}